<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <path
    d="M19.2012 8V15.8658M19.2012 15.8658L24.2373 11.7531M19.2012 15.8658L14 11.7531"
    stroke="#233F1F"
    stroke-width="1.5" />
  <path d="M24.2373 15.866L19.2025 19.9609L14 15.866" stroke="#233F1F" stroke-width="1.5" />
  <path
    d="M24.2373 20.3701L19.2025 24.2676M19.2025 24.2676L14 20.3701M19.2025 24.2676V29"
    stroke="#233F1F"
    stroke-width="1.5" />
</template>
